import {
  GridCellParams,
  GridFilterItem,
  GridFilterOperator,
  getGridSingleSelectOperators
} from '@mui/x-data-grid';

type EvaluationOption = { id: number; title: string };

const isOperator = getGridSingleSelectOperators().find(
  (operator) => operator.value === 'is'
);

if (!isOperator) {
  throw new Error("Could not find the 'is' operator from MUI DataGrid.");
}

const evaluationOperator: GridFilterOperator[] = [
  {
    ...isOperator,
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      if (!filterItem.value) {
        return null;
      }

      return (params: GridCellParams<EvaluationOption>) => {
        const { value } = params;
        if (!value || typeof value !== 'object' || !('id' in value)) {
          return false;
        }
        const selected = filterItem.value;
        return selected.id === value.id;
      };
    }
  }
];

export default evaluationOperator;
